<template>
  <div class="wrapper">
    <ShadowBackground />
    <div class="promo_common_popup" v-bind:style="scaleStyle">
      <CommonPopupBackground :height="backgroundHeight" :width="backgroundWidth" />
      <ActivePromoPanel :onSelectActivityHandler="onSelectActivityClick"></ActivePromoPanel>
      <div :class="[isActiveLandscape ? 'promo_common_popup_right_panel' : 'promo_common_popup_right_panel_portrait']">
        <div
          :class="[
            isActiveLandscape
              ? 'promo_common_popup_right_panel_header'
              : 'promo_common_popup_right_panel_header_portrait'
          ]">
          <img
            v-show="getSelectedActivity.type === 'tournament'"
            :src="getTournamentIcon"
            :style="{ left: (isActiveLandscape ? 152 : 112) + 'px', top: (isActiveLandscape ? 5 : 15) + 'px' }"
            alt=""
            style="position: absolute" />
          <div
            :style="{ top: (isActiveLandscape ? 10 : 15) + 'px' }"
            class="promo_common_popup_right_panel_header__name">
            {{ getSelectedActivity.name }}
          </div>
          <div
            :class="[
              isActiveLandscape ? 'promo_common_popup_button_close' : 'promo_common_popup_button_close_portrait'
            ]"
            v-on:click="onCloseClick">
            <CloseButton />
          </div>
        </div>
        <div
          :class="[
            isActiveLandscape ? 'promo_common_popup_right_panel_tabs' : 'promo_common_popup_right_panel_tabs_portrait'
          ]">
          <div v-show="getSelectedActivity.type === 'tournament'">
            <div
              :style="{ left: (isActiveLandscape ? 0 : 15) + 'px', width: (isActiveLandscape ? 190 : 180) + 'px' }"
              style="position: absolute; height: 100%; cursor: pointer"
              v-on:click="() => onSelectActivityTabClick(0)">
              <div :class="getSelectedActivity.selectedTabIndex === 0 ? 'active__tab' : ''" class="default__tab"></div>
              <div style="position: absolute; text-align: center; left: 0; right: 0; top: 7px; font-size: 28px">
                {{ $t('common_popup.prizes') }}
              </div>
            </div>

            <div
              :style="{ left: (isActiveLandscape ? 215 : 225) + 'px', width: (isActiveLandscape ? 190 : 180) + 'px' }"
              style="position: absolute; height: 100%; cursor: pointer"
              v-on:click="() => onSelectActivityTabClick(1)">
              <div :class="getSelectedActivity.selectedTabIndex === 1 ? 'active__tab' : ''" class="default__tab"></div>
              <div style="position: absolute; text-align: center; left: 0; right: 0; top: 7px; font-size: 28px">
                {{ $t('common_popup.leaderboard') }}
              </div>
            </div>

            <div
              :style="{ left: (isActiveLandscape ? 430 : 434) + 'px', width: (isActiveLandscape ? 190 : 180) + 'px' }"
              style="position: absolute; height: 100%; cursor: pointer"
              v-on:click="() => onSelectActivityTabClick(2)">
              <div :class="getSelectedActivity.selectedTabIndex === 2 ? 'active__tab' : ''" class="default__tab"></div>
              <div style="position: absolute; text-align: center; left: 0; right: 0; top: 7px; font-size: 28px">
                {{ $t('common_popup.rules') }}
              </div>
            </div>
          </div>
        </div>

        <div
          v-show="getSelectedActivity.selectedTabIndex === 0"
          :style="{ top: (isActiveLandscape ? 109 : 114) + 'px', height: (isActiveLandscape ? 484 : 520) + 'px' }"
          style="position: absolute; width: 100%">
          <div class="promo_common_popup_selectedTab">
            <p style="position: absolute; left: 10px; top: 12px; font-size: 24px; text-align: left">
              {{ $t('common_popup.place') }}
            </p>
            <p style="position: absolute; right: 10px; top: 12px; font-size: 24px; text-align: right">
              {{ $t('common_popup.prize') }}
            </p>
            <div
              :style="{ height: (isActiveLandscape ? 434 : 470) + 'px' }"
              style="position: absolute; width: 100%; height: 432px; left: 0; top: 50px; overflow-y: auto">
              <div>
                <div v-for="(item, index) in getSelectedActivity.rules.prizes" :key="index" class="promo_table_item">
                  <p>{{ item.from }} - {{ item.to }}</p>
                  <div class="promo_prizes_box">
                    <p>{{ getPrizeFormat(item) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-show="getSelectedActivity.selectedTabIndex === 1"
          :style="{ top: (isActiveLandscape ? 109 : 114) + 'px', height: (isActiveLandscape ? 484 : 520) + 'px' }"
          style="position: absolute; width: 100%">
          <p class="min-rounds" v-if="Number(getMinRounds) - Number(getMinRoundsProgress) > 0">
            {{ $t('common_popup.leaderboard_1', { Xspins: getMinRounds -  getMinRoundsProgress, Yspins: getMinRounds })  }}
          </p>
          <div class="promo_common_popup_selectedTab">
            <p style="position: absolute; left: 10px; top: 12px; font-size: 24px; text-align: left">
              {{ $t('common_popup.place') }}
            </p>
            <p style="position: absolute; right: 10px; top: 12px; font-size: 24px; text-align: right">
              {{ $t('common_popup.score') }}
            </p>
            <div
              :style="{ height: (isActiveLandscape ? 434 : 470) + 'px' }"
              style="position: absolute; width: 100%; left: 0; top: 50px; overflow-y: auto">
              <div>
                <div
                  v-for="(item, index) in getSelectedActivity.players"
                  :key="index"
                  :class="[item.player === 'me' ? 'promo_selected_value' : '', 'promo_table_item']">
                  <p>{{ item.place || '-' }}</p>
                  <p style="width: calc(100% - 15px); position: absolute; text-align: center">{{ item.player }}</p>
                  <p>{{ getScoreFormat(item.score) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-show="getSelectedActivity.selectedTabIndex === 2"
          :style="{ top: (isActiveLandscape ? 109 : 114) + 'px', height: (isActiveLandscape ? 484 : 520) + 'px' }"
          style="overflow-y: auto; position: absolute; width: 100%; color: white"
          @wheel="scrollCanceled">
          <div class="promo_common_popup_rule">
            <h1 class="promo_common_popup_rule__title">
              {{ $t('common_popup.rules_title') }}
            </h1>
            <ul>
              <li>
                {{ $t('common_popup.rules_text_1') }}
              </li>

              <li>
                {{ $t('common_popup.rules_text_2') }}
                <span class="promo_selected_value">{{ getTournamentGameNamesList }}</span>
              </li>

              <li>
                {{ $t('common_popup.rules_text_3') }}
                {{ $t('from') }}
                <span class="promo_selected_value"> {{ getTournamentStartData }}</span>
                {{ $t('to') }}
                <span class="promo_selected_value"> {{ getTournamentFinishData }}</span>
              </li>

              <li>
                {{ $t('common_popup.rules_text_4') }}
                <span class="promo_selected_value"> {{ getTournamentTotalPrize }}</span>
              </li>

              <li>
                {{ $t('common_popup.rules_text_5') }}
              </li>

              <li v-if="isProviderPatriana">
                4.1 To participate in the tournament, the player must go to the
                Gamzix games and choose a play amount with a coin type from
                <span class="promo_selected_value">
                  {{ getTournamentMinBet }} {{ getFormatedCurrency }}
                </span> and above.
              </li>

              <li v-else>
                {{ $t('common_popup.rules_text_5_1_1', { currencyCode: getFormatedCurrency }) }}
                <span class="promo_selected_value"> {{ getTournamentMinBet }} {{ getFormatedCurrency }}</span>
                {{ $t('common_popup.rules_text_5_1_2') }}
              </li>

              <li>
                {{ $t('common_popup.rules_text_5_2') }}
              </li>

              <li v-if="getRules.betPoints">
                <div>
                  {{ $t('common_popup.rules_text_5_3_bet_1') }}
                  <span class="promo_selected_value"> 1 {{ getFormatedCurrency }}</span>
                  =
                  <span class="promo_selected_value">{{ getRules.betPoints }}</span>
                  {{ $t('common_popup.rules_text_5_3_bet_2') }}
                </div>
              </li>

              <li v-if="getRules.winPoints">
                {{ $t('common_popup.rules_text_5_3_win_1') }}
                <span class="promo_selected_value"> 1 {{ getFormatedCurrency }}</span>
                =
                <span class="promo_selected_value">{{ getRules.winPoints }}</span>
                {{ $t('common_popup.rules_text_5_3_win_2') }}
              </li>

              <li v-if="getRules.roundPoints">
                {{ $t('common_popup.rules_text_5_3_round_1') }}
                <span class="promo_selected_value">{{ getRules.roundPoints }}</span>
                {{ $t('common_popup.rules_text_5_3_round_2') }}
              </li>

              <li v-if="getRules.winToBetPoints">
                {{ $t(`common_popup.${winToBetSettings.text}`) }}
                <span v-if="winToBetSettings.isMoney" class="promo_selected_value">{{ getRules.winToBetPoints }}</span>
              </li>

              <li>
                {{ $t(`common_popup.rules_text_5_4`) }}
              </li>

              <li>
                {{
                  $t(`common_popup.rules_text_5_5`, {
                    hours: getHours(getTournamentFinishedAt, getTournamentClosedAt)
                  })
                }}
              </li>

              <template v-for="(item, index) in listRule">
                <li v-if="item.condition" :key="index">
                  {{ $t(`common_popup.rules_text_${item.text}`) }}
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import ActivePromoPanel from '@/components/common_popup/ActivePromoPanel.vue';
import ShadowBackground from '@/components/otherComponents/ShadowBackground.vue';
import CloseButton from '@/components/otherComponents/CloseButton.vue';
import CommonPopupBackground from '@/components/common_popup/components/CommonPopupBackground.vue';
import { mapGetters } from 'vuex';
import { Utils } from '@/utils/Utils';
import { ACTION } from '@/store/ACTION';

export default Vue.extend({
  name: 'CommonPopup',
  components: {
    ActivePromoPanel,
    ShadowBackground,
    CloseButton,
    CommonPopupBackground
  },
  computed: {
    ...mapGetters([
      'getPromoActivityList',
      'getAppConfiguration',
      'getTournamentCurrency',
      'getTournamentGameNamesList',
      'getTournamentStartData',
      'getTournamentFinishData',
      'getTournamentFinishedAt',
      'getTournamentClosedAt',
      'getTournamentMinBet',
      'getRules',
      'getAutoCharge',
      'isSoftSwiss',
      'getTournamentTotalPrize',
      'isTournamentWinToBetForX',
      'getLang',
      'getMinRounds',
      'getMinRoundsProgress'
    ]),
    currentProvider(): string {
      return Utils.parseGetParams('provider') || '';
    },
    isProviderPatriana(): boolean {
      return this.currentProvider === 'patriana';
    },
    getFormatedCurrency(): string {
      return Utils.formatCurrencyCodeToMili(this.getTournamentCurrency);
    },
    listRule(): { text: string; condition: boolean }[] {
      return [
        {
          text: '6',
          condition: true
        },
        {
          text: '7',
          condition: true
        },
        {
          text: '8',
          condition: true
        },
        {
          text: '9',
          condition: true
        },
        {
          text: '10',
          condition: true
        },
        {
          text: '11',
          condition: this.getAutoCharge
        }
      ];
    },
    getSelectedActivity(): any {
      return this.getPromoActivityList.find((el: any) => el.isSelected) || { rules: { prizes: [] }, players: [] };
    },
    scaleStyle(): { transform: string; top: string; left: string; width: string; height: string } {
      const { isLandscape, scale: scaleData } = this.getAppConfiguration;
      const offset: { top: number; left: number } = {
        top: isLandscape ? 628 / 2 : 863 / 2,
        left: isLandscape ? 979 / 2 : 520 / 2
      };
      const scale: number = scaleData;
      const addScale: number = isLandscape ? 1.5 : 2;

      return {
        transform: `scale(${scale * addScale})`,
        top: `calc(50% - ${offset.top}px)`,
        left: `calc(50% - ${offset.left}px)`,
        width: this.backgroundWidth + 'px',
        height: this.backgroundHeight + 'px'
      };
    },
    backgroundWidth(): number {
      return this.getAppConfiguration.isLandscape ? 974 : 520;
    },
    backgroundHeight(): number {
      return this.getAppConfiguration.isLandscape ? 628 : 862;
    },
    isActiveLandscape(): boolean {
      return this.getAppConfiguration.isLandscape;
    },
    winToBetSettings(): { text: string; isMoney: boolean } {
      switch (true) {
        case this.isTournamentWinToBetForX:
          return {
            text: 'rules_text_5_3_win_to_bet_for_X',
            isMoney: false
          };
        default:
          return {
            text: 'rules_text_5_3_win_to_bet',
            isMoney: true
          };
      }
    },
    getTournamentIcon(): string {
      return `${__PROMO_CONFIG.STATIC_URL}/assets/img/common_popup/tournament_icon.png`;
    }
  },
  methods: {
    getPrizeFormat({ amount = '', amountFS = '' }): string {
      const money: string =
        Number(amount) !== 0
          ? `${Utils.centsToMoneyStr(
              Number(amount),
              this.getRules.currencyDecimals,
              this.getTournamentCurrency,
              false
            )} ${this.getFormatedCurrency}`
          : '';
      const freeSpins: string = amountFS ? amountFS + ' FS' : '';
      const plus: string = money && freeSpins ? ' + ' : '';
      return money + plus + freeSpins;
    },
    getHours(resultedAt: string, finishedAt: string): number {
      const startDate: Date = new Date(resultedAt);
      const endDate: Date = new Date(finishedAt);
      const differenceInMs: number = endDate.getTime() - startDate.getTime();
      const differenceInHours: number = differenceInMs / (1000 * 60 * 60);
      const minutes = (differenceInMs % (1000 * 60 * 60)) / (1000 * 60);
      const roundedHours = minutes >= 30 ? Math.ceil(differenceInHours) : Math.floor(differenceInHours);

      return roundedHours;
    },
    getScoreFormat(score: number): string {
      return Number(score).toFixed(2);
    },
    onSelectActivityTabClick(index: number): void {
      const currentActivity = this.getSelectedActivity;
      currentActivity.selectedTabIndex = index;
    },
    onSelectActivityClick(index: number): void {
      this.getPromoActivityList.forEach((el: any) => (el.isSelected = false));
      this.getPromoActivityList[index].isSelected = true;
    },
    onCloseClick(): void {
      this.$store.dispatch(ACTION.HIDE_COMMON_POPUP);
    },
    scrollCanceled(e: any) {
      e.stopPropagation();
    }
  }
});
</script>

<style scoped>
img {
  max-width: none;
}

.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.promo_common_popup {
  position: absolute;
}

.promo_table_item {
  display: flex;
  justify-content: space-between;
  padding: 5px 12px 5px 10px;
  align-items: center;
  font-size: 22px;
  font-family: myriadpro-boldcond, sans-serif;
  background: #383c3d; /* Цвет фона */
}

.promo_prizes_box {
  display: flex;
}

.promo_table_item:nth-child(2n) {
  background: rgba(0, 0, 0, 0); /* Цвет фона */
}

.promo_selected_value {
  color: #ffe900;
}

.promo_common_popup_right_panel {
  position: absolute;
  top: 10px;
  left: 345px;
  /*background-color: #33f93d;*/
  width: 620px;
  height: 608px;
}

.promo_common_popup_right_panel_header {
  position: absolute;
  text-align: center;
  color: white;
  top: 0;
  left: 0;
  /*background-color: #335bf9;*/
  width: 100%;
  height: 63px;
}

.promo_common_popup_right_panel_header__name {
  font-family: myriadpro-bold, sans-serif;
  text-align: center;
  position: absolute;
  left: 60px;
  right: 0;
  color: white;
  font-size: 34px;
}

.promo_common_popup_right_panel_tabs {
  font-family: myriadpro-boldcond, sans-serif;
  position: absolute;
  text-align: center;
  color: white;
  top: 61px;
  left: 0;
  /*background-color: #7113a2;*/
  width: 100%;
  height: 46px;
}

.promo_common_popup_selectedTab {
  font-family: myriadpro-cond, sans-serif;
  position: absolute;
  left: 0;
  right: 0;
  font-size: 20px;
  margin: auto;
  color: white;
  width: 100%;
  height: 50px;
}

.promo_common_popup_selectedTab__list {
  font-family: myriadpro-boldcond, sans-serif;
  position: relative;
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #ffffff40;
}

.promo_common_popup_button_close {
  position: absolute;
  top: 5px;
  right: -5px;
  left: 0;
  margin-left: auto;
  width: 55px;
  height: 55px;
  transition: all 0.1s ease;
}

.promo_common_popup_button_close:hover {
  transform: scale(1.05);
  cursor: pointer;
}

.promo_common_popup_button_close:active {
  transform: scale(0.95);
  cursor: pointer;
}

/* portrait styles */

.promo_common_popup_left_panel_portrait {
  display: flex;
  overflow-x: auto;
  overflow-y: auto;
  position: absolute;
  top: 678px;
  left: 10px;
  /*background-color: #f9b733;*/
  width: 480px;
  height: 175px;
  padding: 10px;
  justify-content: center;
}

.promo_common_popup_left_panel_item_portrait {
  cursor: pointer;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  /*background-color: #4bd23e;*/
  width: 283px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 15px;
}

.promo_common_popup_right_panel_portrait {
  position: absolute;
  top: 0;
  left: 0;
  /* background-color: #33f93d; */
  width: 500px;
  height: 634px;
  padding: 10px;
}

.promo_common_popup_right_panel_header_portrait {
  position: absolute;
  text-align: center;
  color: white;
  top: 0;
  left: 0;
  /*background-color: #335bf9;*/
  width: 100%;
  height: 63px;
}

.promo_common_popup_right_panel_tabs_portrait {
  position: absolute;
  text-align: center;
  color: white;
  top: 68px;
  left: -44px;
  /* background-color: #7113a2; */
  width: 100%;
  height: 46px;
  transform: scale(0.834);
  font-family: myriadpro-boldcond, sans-serif;
}

.promo_common_popup_button_close_portrait {
  position: absolute;
  top: 15px;
  right: -15px;
  left: 0;
  margin-left: auto;
  width: 55px;
  height: 55px;
  transition: all 0.1s ease;
}

.promo_common_popup_button_close_portrait:hover {
  transform: scale(1.05);
  cursor: pointer;
}

.promo_common_popup_button_close_portrait:active {
  transform: scale(0.95);
  cursor: pointer;
}

.promo_common_popup_rule {
  padding-left: 10px;
  padding-right: 10px;
  font-size: 18px;
}

.promo_common_popup_rule__title {
  font-family: myriadpro-bold, sans-serif;
  font-size: 20px;
  color: #ffffff;
  font-weight: bold;
  text-align: center;
  margin: 20px 0 20px 0;
}

.promo_common_popup_rule li {
  font-family: myriadpro-boldcond, sans-serif;
}

.default__tab {
  width: 100%;
  height: 3px;
  background-color: #737373;
  position: absolute;
  bottom: 0;
  transition: all 0.3s ease;
}

.active__tab {
  background-color: #fff;
  box-shadow: 0px -10px 20px #ffffff;
}

.min-rounds {
  display: block; 
  width: 100%; 
  text-align: center; 
  color: #fff; 
  margin-bottom: -15px; 
  font-family: myriadpro-cond, sans-serif; 
  margin-top: 5px;
}
</style>
